import React from "react";
import Container from "../../components/layouts/Container";
import { ContextLanguage } from "../../context/Context.Language";
import {
  TEXT_ALL_OF,
  TEXT_AVAILABLE,
  TEXT_AVAILABLE_POLICY,
  TEXT_CLAUSE_I,
  TEXT_CLAUSE_II,
  TEXT_CONTACT_US,
  TEXT_COOKIES,
  TEXT_COOKIES_1,
  TEXT_DATA_RETENTION,
  TEXT_EACH_TIME_III,
  TEXT_GOOGLE_PRODUCT,
  TEXT_GOOGLE_PRODUCT_1,
  TEXT_GOOGLE_PRODUCT_2,
  TEXT_GOOGLE_PRODUCT_3,
  TEXT_GOOGLE_PRODUCT_4,
  TEXT_GOOGLE_PRODUCT_5,
  TEXT_HERE,
  TEXT_INGENERAL_PROVICY,
  TEXT_IN_CASE_PRIVACY_1,
  TEXT_IN_CASE_PRIVACY_2,
  TEXT_IN_CASE_PRIVACY_3,
  TEXT_IN_ORDER_TO,
  TEXT_IT_IS_NECESSARY,
  TEXT_LEGALLY,
  TEXT_MY_LAUNDRY,
  TEXT_MY_LAUNDRY_WILL_NOT,
  TEXT_MY_LAUNDRY_WILL_NOT_2,
  TEXT_NOTE_THAT_YOU_PROVICY,
  TEXT_PRIVACY_NOTICE_1,
  TEXT_PRIVACY_NOTICE_1_1,
  TEXT_PRIVACY_NOTICE_2,
  TEXT_PRIVACY_NOTICE_2_1,
  TEXT_PRIVACY_NOTICE_2_2,
  TEXT_PRIVACY_NOTICE_2_3,
  TEXT_PRIVACY_NOTICE_II,
  TEXT_PRIVACY_NOTICE_III,
  TEXT_PRIVACY_NOTICE_III_1,
  TEXT_PRIVACY_NOTICE_III_1_1,
  TEXT_PRIVACY_NOTICE_III_1_2,
  TEXT_PRIVACY_NOTICE_III_1_3,
  TEXT_PRIVACY_NOTICE_III_1_4,
  TEXT_PRIVACY_NOTICE_III_1_5,
  TEXT_PRIVACY_NOTICE_III_1_6,
  TEXT_PRIVACY_NOTICE_III_1_7,
  TEXT_PRIVACY_NOTICE_II_1,
  TEXT_PRIVACY_NOTICE_II_1_1,
  TEXT_PRIVACY_NOTICE_II_1_1_1,
  TEXT_PRIVACY_NOTICE_II_1_2,
  TEXT_PRIVACY_NOTICE_II_1_2_2,
  TEXT_PRIVACY_NOTICE_II_1_3,
  TEXT_PRIVACY_NOTICE_II_1_3_3,
  TEXT_PRIVACY_NOTICE_II_1_4,
  TEXT_PRIVACY_NOTICE_II_1_4_4,
  TEXT_PRIVACY_NOTICE_II_1_5,
  TEXT_PRIVACY_NOTICE_II_1_6,
  TEXT_PRIVACY_NOTICE_II_1_6_1,
  TEXT_PRIVACY_NOTICE_II_1_6_2,
  TEXT_PRIVACY_NOTICE_II_1_7,
  TEXT_PRIVACY_NOTICE_II_1_7_1,
  TEXT_PRIVACY_NOTICE_II_1_8,
  TEXT_PRIVACY_NOTICE_II_1_8_1,
  TEXT_PRIVACY_NOTICE_II_1_GENERAL,
  TEXT_PRIVACY_NOTICE_II_1_OPERATE,
  TEXT_PRIVACY_POLICY,
  TEXT_PRIVACY_POLICY_TITLE,
  TEXT_PRIVACY_POLICY_TITLE_1_2,
  TEXT_PRIVACY_POLICY_TITLE_2,
  TEXT_PRIVACY_POLICY_TITLE_3,
  TEXT_PROVIDING_1,
  TEXT_PROVIDING_A,
  TEXT_PROVIDING_A_1,
  TEXT_PROVIDING_B,
  TEXT_PROVIDING_B_2,
  TEXT_PROVIDING_C,
  TEXT_PROVIDING_C_3,
  TEXT_PROVIDING_D,
  TEXT_PROVIDING_D_3,
  TEXT_PROVIDING_YOUR_PERSONAL_DATA,
  TEXT_PROVIDING_YOUR_PERSONAL_DATA_TO_OTHERS,
  TEXT_SECURYTY_1,
  TEXT_SECURYTY_2,
  TEXT_SECURYTY_2_2,
  TEXT_SECURYTY_IV,
  TEXT_SOCIAL_MEDIA_1,
  TEXT_SOCIAL_MEDIA_10,
  TEXT_SOCIAL_MEDIA_11,
  TEXT_SOCIAL_MEDIA_12,
  TEXT_SOCIAL_MEDIA_13,
  TEXT_SOCIAL_MEDIA_14,
  TEXT_SOCIAL_MEDIA_1_2,
  TEXT_SOCIAL_MEDIA_2,
  TEXT_SOCIAL_MEDIA_3,
  TEXT_SOCIAL_MEDIA_4,
  TEXT_SOCIAL_MEDIA_5,
  TEXT_SOCIAL_MEDIA_6,
  TEXT_SOCIAL_MEDIA_7,
  TEXT_SOCIAL_MEDIA_8,
  TEXT_SOCIAL_MEDIA_9,
  TEXT_SOCIAL_MEDIA_PROVICY,
  TEXT_SOCIAL_MEDIA_PROVICY_1,
  TEXT_TEL,
  TEXT_THE,
  TEXT_THE_RIGHTS_1,
  TEXT_THE_RIGHTS_1_2,
  TEXT_THE_RIGHTS_2,
  TEXT_THE_RIGHTS_3,
  TEXT_THE_RIGHTS_3_3,
  TEXT_THE_RIGHTS_4,
  TEXT_THE_RIGHTS_4_4,
  TEXT_THE_RIGHTS_5,
  TEXT_THE_RIGHTS_6,
  TEXT_THE_RIGHTS_6_6,
  TEXT_THE_RIGHTS_7,
  TEXT_THE_RIGHTS_7_7,
  TEXT_THE_RIGHTS_8,
  TEXT_THE_RIGHTS_8_8,
  TEXT_THE_RIGHT_2_2,
  TEXT_THE_RIGHT_5_5,
  TEXT_THE_TEMPORALY,
  TEXT_WE_PROCESS_PROVICY,
  TEXT_WE_WILL_USE,
  TEXT_WE_WOULD_LIKE_PROVICY,
  TEXT_WE_WOULD_LIKE_PROVICY_2,
  TEXT_WHEN_YOU_MAKE_A_PAYMENT,
  TEXT_WHERE_WE_PROCESS_PROVICY,
  TEXT_YOUR_RIGHTS,
  TEXT_YOU_CONSENT_AND_AGREE,
} from "../../utils/useConstants";
import { ICON_CHEVRON_LEFT } from "../../utils/useIcons";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_ADDRESS_BG,
  STYLE_BUTTON_ICON_LEFT,
  STYLE_CONTAINER_NO_PADDING_READ,
  STYLE_LINK_BLUE,
  STYLE_LINK_BLUE_NO_MX,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MIN_H_FULL,
  STYLE_PADDING_WINDOWS,
  STYLE_PROGRAM_BACK,
  STYLE_SUBTITLE_SEMIBOLD,
  STYLE_SUB_NO_TERM,
  STYLE_TEXT_DETAIL,
  STYLE_TITLE_TEARM_POLICY,
  STYLE_TITLE_TEARM_POLICY_MB,
  STYLE_UNDERLINE_BLUE_TERM,
  STYLE_UNDERLINE_PRIVACY,
} from "../../utils/useStyle";
import ProgramClickBack from "../task/functions/Program.ClickBack";
import { useNavigate } from "react-router-dom";
import { PrivacyFirstLoad } from "./functions/Privacy.FirstLoad";
import { FunctionOpenInNewTab } from "radium-omnibus";
import ProgramGoBack from "../task/render/Program.GoBack";
import MetaTags from "../../utils/useMetaTags";

const PrivacyMain = () => {
  React.useEffect(() => {
    PrivacyFirstLoad();
  }, []);
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  return (
    <div id="scroll_privacy">
      {language === "TH" ? (
        <MetaTags
          title="ประกาศความเป็นส่วนตัว - กรุงเทพ | My Laundry"
          description="My Laundry นอกจากเชี่ยวชาญในการซักรีดและซักรองเท้าแล้ว เรายังปกป้องข้อมูลส่วนตัวของคุณด้วย รายละเอียดเพิ่มเติมที่ ประกาศความเป็นส่วนตัว!"
        />
      ) : (
        <MetaTags
          title="Privacy Notice ¬- Bangkok | My Laundry"
          description="My Laundry is not only professional when it comes to laundry and shoes, but also in how we protect your data. Learn more about our Privacy Notice!"
        />
      )}

      <Container style={STYLE_CONTAINER_NO_PADDING_READ}>
        <div className={`max-w-desktop px-0 md:px-10 xl:px-37 mx-auto`}>
          <div
            className={`bg-white  md:ordershadow px-4 md:px-6 md:pb-[30px] md:rounded-xl h-full relative ${STYLE_MIN_H_FULL}`}
          >
            {/* <div
              className={`flex  md:grid grid-cols-6 ${STYLE_PROGRAM_BACK(
                language
              )}`}
            >
              <ICON_CHEVRON_LEFT
                className={STYLE_BUTTON_ICON_LEFT}
                onClick={() => {
                  ProgramClickBack(navigate);
                }}
              />
              <div className=" mx-auto md:col-span-4">
                {isMobile ? (
                  <div className={STYLE_TITLE_TEARM_POLICY_MB(language)}>
                    {TEXT_PRIVACY_POLICY[language]}
                  </div>
                ) : (
                  <div className={STYLE_TITLE_TEARM_POLICY(language)}>
                    {TEXT_PRIVACY_POLICY[language]}
                  </div>
                )}
              </div>
            </div> */}
            <ProgramGoBack
              marginarrow="md:ml-[130px]"
              title={TEXT_PRIVACY_POLICY[language]}
              textcolor={`${
                language === "TH"
                  ? " text-xl-th md:text-28-th w-fit "
                  : " ttext-xl md:text-28 w-fit "
              } `}
            />
            <div className="block md:grid md:grid-cols-2 gap-4 md:gap-[68px]">
              <div
                className={`${STYLE_TEXT_DETAIL(language)} ${
                  language === "EN" && "leading-5"
                } `}
              >
                {/* <div>{TEXT_PRIVACY_POLICY_TITLE[language]}</div> */}
                <div>
                  {language === "TH" ? (
                    <span>
                      My Laundry ("เรา") ให้บริการซักรีด รีดผ้า
                      ทำความสะอาดรองเท้า และบริการจัดส่งน้ำอย่างมืออาชีพ ("
                      <span className="font-bold">บริการ</span>") ให้แก่ลูกค้า
                    </span>
                  ) : (
                    <span>
                      My Laundry ("we," "us," "our") provides professional
                      laundry, ironing, shoe cleaning, and water delivery
                      services ("<span className="font-bold">Services</span>")
                      for the customers.
                    </span>
                  )}
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)} my-3 `}>
                  {/* {TEXT_PRIVACY_POLICY_TITLE_1_2[language]} */}
                  <span>
                    {language === "TH" ? (
                      <span>
                        เอกสารนี้ ("
                        <span className="font-bold">ประกาศความเป็นส่วนตัว</span>
                        ") ทำหน้าที่ให้ข้อมูลเกี่ยวกับการรวบรวม การใช้
                        การเปิดเผย การบริหาร และการจัดการข้อมูลส่วนบุคคลของ My
                        Laundry ซึ่งเป็นกิจการเจ้าของคนเดียวโดยฌรัลย์ธาร
                        วรการปรีชาวุฒิ ได้จดทะเบียนการค้าเมื่อวันที่ 9 มีนาคม
                        2565 ที่เขตป้อมปราบศัตรูพ่าย
                        ซึ่งดำเนินธุรกิจโดยใช้ชื่อทางการค้าว่า “My Laundry”
                        เลขทะเบียนที่ 1100800732810 และที่อยู่จดทะเบียน 128/71
                        ซอยแม้นศรี แขวงคลองมหานาค เขตป้อมปราบศัตรูพ่าย กรุงเทพฯ
                        10100 My Laundry ทำการรวบรวม ใช้ เปิดเผย
                        บริหารและจัดการข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
                        พ.ศ. 2562 ("
                        <span className="font-bold">
                          พรบ. คุ้มครองข้อมูลส่วนบุคคล
                        </span>
                        ") เมื่อมีการเข้าถึงเว็บไซต์ของเรา มีการใช้บริการใดๆ ของ
                        My Laundry มีการจัดส่งข้อมูลใดๆ ให้เรา
                        หรือแสดงข้อตกลงของท่าน
                        จะถือว่าท่านได้ตกลงและยินยอมตามข้อกำหนดของประกาศความเป็นส่วนตัวนี้
                        เมื่อมีการเข้าถึงเว็บไซต์ของเรา
                        ท่านสามารถคลิกที่ลิงก์เพื่อเข้าถึงรายละเอียดของประกาศความเป็นส่วนตัว
                        และท่านจะได้รับการร้องขอให้แสดงความยินยอมโดยคลิกที่ปุ่ม
                      </span>
                    ) : (
                      <span>
                        This document ("
                        <span className="font-bold">Privacy Notice</span>")
                        serves to provide information on the collection, use,
                        disclosure, management, and handling of Personal Data by
                        My Laundry, a Sole Proprietorship under Sharunthal
                        Vorakarnpreechavuth, registered on 9 March 2022 through
                        Commercial Registration at Pom Prab Sattru Phai
                        District, operating with the Commercial name of “My
                        Laundry” and registration number 1100800732810, and
                        having its registered address at 128/71 Soi Maensri,
                        Khlong Maha Nak, Pomprab Sattru Phai, Bangkok, 10100. My
                        Laundry collects, uses, discloses, manages, and handles
                        Personal Data subject to the Personal Data Protection
                        Act B.E. 2562 ("<span className="font-bold">PDPA</span>
                        "). By accessing our website, using any services
                        provided by My Laundry, submitting any information to
                        us, or otherwise showing your agreement thereon, you
                        will be deemed to have agreed and consented to the terms
                        of this Privacy Notice. When accessing our website, you
                        can click on a link to access the details of our privacy
                        notice and you will be requested to provide your consent
                        by clicking on a button.
                      </span>
                    )}{" "}
                  </span>
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                  {TEXT_PRIVACY_POLICY_TITLE_2[language]}
                </div>
                <div
                  className={`${STYLE_SUBTITLE_SEMIBOLD(
                    language
                  )} my-3 ${STYLE_UNDERLINE_PRIVACY}`}
                >
                  {TEXT_PRIVACY_POLICY_TITLE_3[language]}
                </div>
                <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                  {TEXT_PRIVACY_NOTICE_1[language]}
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}`}>
                  <div>{TEXT_MY_LAUNDRY[language]}</div>
                  <div>{TEXT_PRIVACY_NOTICE_1_1[language]}</div>
                  <div>
                    {TEXT_TEL[language]} <span> +66 (0) 92-516-5458</span>
                  </div>
                  <div>contact@mylaundrythai.com</div>
                  <div
                  // onClick={() => {
                  //   FunctionOpenInNewTab("https://www.mylaundrythai.com");
                  // }}
                  // className={`${STYLE_LINK_BLUE} -ml-0.5 w-fit`}
                  >
                    www.mylaundrythai.com
                  </div>
                </div>
                <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                  2. {language === "TH" ? `ติดต่อเรา` : `Contact us`}
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                  {TEXT_PRIVACY_NOTICE_2[language]}
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    {TEXT_PRIVACY_NOTICE_2_1[language]}
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      {TEXT_PRIVACY_NOTICE_2_2[language]}
                      {TEXT_PRIVACY_NOTICE_2_3[language]}
                    </div>
                  </div>
                </div>
                <div
                  className={`${STYLE_SUBTITLE_SEMIBOLD(
                    language
                  )} my-3 ${STYLE_UNDERLINE_PRIVACY}`}
                >
                  {TEXT_PRIVACY_NOTICE_II[language]}
                </div>
                <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                  1. {TEXT_PRIVACY_NOTICE_II_1[language]}
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                  {TEXT_PRIVACY_NOTICE_II_1_GENERAL[language]}
                  {TEXT_IN_ORDER_TO[language]}
                  {TEXT_PRIVACY_NOTICE_II_1_OPERATE[language]}
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_PRIVACY_NOTICE_II_1_1[language]}
                      </span>
                      {TEXT_PRIVACY_NOTICE_II_1_1_1[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_PRIVACY_NOTICE_II_1_2[language]}
                      </span>
                      {TEXT_PRIVACY_NOTICE_II_1_2_2[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_PRIVACY_NOTICE_II_1_3[language]}
                      </span>
                      {TEXT_PRIVACY_NOTICE_II_1_3_3[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_PRIVACY_NOTICE_II_1_4[language]}
                      </span>
                      {TEXT_PRIVACY_NOTICE_II_1_4_4[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div className={`${STYLE_UNDERLINE_PRIVACY}`}>
                      {TEXT_PRIVACY_NOTICE_II_1_5[language]}
                    </div>
                  </div>
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                  {TEXT_WHEN_YOU_MAKE_A_PAYMENT[language]}
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                  {TEXT_WE_PROCESS_PROVICY[language]}

                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_PRIVACY_NOTICE_II_1_6[language]}
                      </span>
                      {TEXT_PRIVACY_NOTICE_II_1_6_1[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_PRIVACY_NOTICE_II_1_7[language]}
                      </span>
                      {TEXT_PRIVACY_NOTICE_II_1_7_1[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_PRIVACY_NOTICE_II_1_8[language]}
                      </span>
                      {TEXT_PRIVACY_NOTICE_II_1_8_1[language]}
                    </div>
                  </div>
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                  {TEXT_NOTE_THAT_YOU_PROVICY[language]}
                </div>
                <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                  2. {TEXT_YOUR_RIGHTS[language]}
                </div>
                <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                  {TEXT_WE_WOULD_LIKE_PROVICY[language]}
                  {TEXT_ALL_OF[language]}
                  {TEXT_WE_WOULD_LIKE_PROVICY_2[language]}

                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span>{TEXT_THE[language]} </span>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_1[language]}
                      </span>
                      {TEXT_THE_RIGHTS_1_2[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span>{TEXT_THE[language]} </span>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_2[language]}
                      </span>
                      {TEXT_THE_RIGHT_2_2[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span>{TEXT_THE[language]} </span>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_3[language]}
                      </span>
                      {TEXT_THE_RIGHTS_3_3[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span>{TEXT_THE[language]} </span>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_4[language]}
                      </span>
                      {TEXT_THE_RIGHTS_4_4[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span>{TEXT_THE[language]} </span>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_5[language]}
                      </span>
                      {TEXT_THE_RIGHT_5_5[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_6[language]}
                      </span>
                      {TEXT_THE_RIGHTS_6_6[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_7[language]}
                      </span>
                      {TEXT_THE_RIGHTS_7_7[language]}
                    </div>
                  </div>
                  <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                    <li></li>
                    <div>
                      <span>{TEXT_THE[language]} </span>
                      <span className={`${STYLE_UNDERLINE_PRIVACY}`}>
                        {TEXT_THE_RIGHTS_8[language]}
                      </span>
                      {TEXT_THE_RIGHTS_8_8[language]}
                    </div>
                  </div>
                  <div>
                    {TEXT_IN_CASE_PRIVACY_1[language]}
                    <span className="font-bold">{TEXT_CLAUSE_I[language]}</span>
                    {TEXT_IN_CASE_PRIVACY_2[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_IN_CASE_PRIVACY_3[language]}
                  </div>
                </div>
              </div>

              <div
                className={`${STYLE_TEXT_DETAIL(language)} ${
                  language === "EN" && "leading-5"
                }`}
              >
                <div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} mb-3`}>
                    3. {TEXT_PROVIDING_YOUR_PERSONAL_DATA_TO_OTHERS[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_PROVIDING_1[language]}
                    <div className={`${STYLE_SUB_NO_TERM} flex gap-1`}>
                      <div>{TEXT_PROVIDING_A[language]}</div>
                      <div>{TEXT_PROVIDING_A_1[language]}</div>
                    </div>
                    <div className={`${STYLE_SUB_NO_TERM} flex gap-1`}>
                      <div>{TEXT_PROVIDING_B[language]}</div>
                      <div>{TEXT_PROVIDING_B_2[language]}</div>
                    </div>
                    <div className={`${STYLE_SUB_NO_TERM} flex gap-1`}>
                      <div>{TEXT_PROVIDING_C[language]}</div>
                      <div>{TEXT_PROVIDING_C_3[language]}</div>
                    </div>
                    <div className={`${STYLE_SUB_NO_TERM} flex gap-1`}>
                      <div>{TEXT_PROVIDING_D[language]}</div>
                      <div>{TEXT_PROVIDING_D_3[language]}</div>
                    </div>
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_YOU_CONSENT_AND_AGREE[language]}
                  </div>

                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_MY_LAUNDRY_WILL_NOT[language]}
                    <span
                      onClick={() => {
                        FunctionOpenInNewTab(
                          "https://aws.amazon.com/agreement/"
                        );
                      }}
                      className={`${STYLE_LINK_BLUE} w-fit`}
                    >
                      https://aws.amazon.com/agreement/
                    </span>
                    {TEXT_MY_LAUNDRY_WILL_NOT_2[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} my-3 `}>
                    {TEXT_WE_WILL_USE[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    4. {TEXT_PROVIDING_YOUR_PERSONAL_DATA[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_IT_IS_NECESSARY[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    5. {TEXT_DATA_RETENTION[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_INGENERAL_PROVICY[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_WHERE_WE_PROCESS_PROVICY[language]}
                  </div>
                  <div
                    className={`${STYLE_SUBTITLE_SEMIBOLD(
                      language
                    )} my-3 ${STYLE_UNDERLINE_PRIVACY}`}
                  >
                    {TEXT_PRIVACY_NOTICE_III[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    {TEXT_PRIVACY_NOTICE_III_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_EACH_TIME_III[language]}
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      {TEXT_PRIVACY_NOTICE_III_1_1[language]}
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      {TEXT_PRIVACY_NOTICE_III_1_2[language]}
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      {TEXT_PRIVACY_NOTICE_III_1_3[language]}
                    </div>
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      {TEXT_PRIVACY_NOTICE_III_1_4[language]}
                    </div>
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      {TEXT_PRIVACY_NOTICE_III_1_5[language]}
                    </div>
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      {TEXT_PRIVACY_NOTICE_III_1_6[language]}
                    </div>
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      {TEXT_PRIVACY_NOTICE_III_1_7[language]}
                    </div>
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_THE_TEMPORALY[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    2.{TEXT_COOKIES[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_COOKIES_1[language]}
                  </div>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    3.{TEXT_GOOGLE_PRODUCT[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} my-3 `}>
                    {TEXT_GOOGLE_PRODUCT_1[language]} (
                    <span
                      onClick={() => {
                        FunctionOpenInNewTab(
                          "https://support.google.com/tagmanager/answer/7157428?hl=en"
                        );
                      }}
                      className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                    >
                      Google Tag Manager Terms of Service - Tag Manager Help
                    </span>
                    ),{TEXT_GOOGLE_PRODUCT_2[language]} (
                    <span
                      onClick={() => {
                        FunctionOpenInNewTab(
                          "https://policies.google.com/terms?hl=en"
                        );
                      }}
                      className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                    >
                      Google Terms of Service – Privacy & Terms – Google
                    </span>
                    ){TEXT_GOOGLE_PRODUCT_3[language]}{" "}
                    <span
                      onClick={() => {
                        FunctionOpenInNewTab(
                          "https://policies.google.com/privacy?hl=en"
                        );
                      }}
                      className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                    >
                      https://policies.google.com/privacy
                    </span>
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)} my-3 `}>
                    {TEXT_GOOGLE_PRODUCT_4[language]}
                    <span
                      onClick={() => {
                        FunctionOpenInNewTab(
                          "https://marketingplatform.google.com/about/"
                        );
                      }}
                      className={`${STYLE_LINK_BLUE} w-fit break-all`}
                    >
                      http://www.google.com/analytics/learn/privacy.html
                    </span>
                  </div>
                  {TEXT_GOOGLE_PRODUCT_5[language]}
                  <span
                    onClick={() => {
                      FunctionOpenInNewTab(
                        "https://tools.google.com/dlpage/gaoptout?hl=None"
                      );
                    }}
                    className={`${STYLE_LINK_BLUE} w-fit`}
                  >
                     Google Analytics Brower Opt-out extra
                    {language === "EN" && "."}
                  </span>
                  <div className={`${STYLE_SUBTITLE_SEMIBOLD(language)} my-3`}>
                    4.{TEXT_SOCIAL_MEDIA_PROVICY[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_SOCIAL_MEDIA_PROVICY_1[language]}
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_1[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab(
                              "https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
                            );
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        ){TEXT_SOCIAL_MEDIA_1_2[language]}
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_2[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab(
                              "https://privacycenter.instagram.com/policy/?entry_point=ig_help_center_data_policy_redirect"
                            );
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        )
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_3[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab(
                              "https://twitter.com/en/privacy"
                            );
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        )
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_4[language]}{" "}
                        {language === "EN" ? (
                          <span>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://policies.google.com/privacy?hl=en&gl=uk"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </span>
                        ) : (
                          <div>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://policies.google.com/privacy?hl=en&gl=uk"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_5[language]}{" "}
                        {language === "EN" ? (
                          <span>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://www.tiktok.com/legal/page/row/privacy-policy/TH"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </span>
                        ) : (
                          <div>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://www.tiktok.com/legal/page/row/privacy-policy/TH"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_6[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab(
                              "https://policy.pinterest.com/en/privacy-policy"
                            );
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        )
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_7[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab(
                              "https://telegram.org/privacy"
                            );
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        )
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_8[language]}{" "}
                        {language === "EN" ? (
                          <span>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://line.me/en/terms/policy/"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </span>
                        ) : (
                          <div>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://line.me/en/terms/policy/"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_9[language]}{" "}
                        {language === "EN" ? (
                          <span>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://www.whatsapp.com/legal/privacy-policy-eea/?lang=en"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </span>
                        ) : (
                          <div>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://www.whatsapp.com/legal/privacy-policy-eea/?lang=en"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_13[language]}{" "}
                        {language === "EN" ? (
                          <span>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://www.wechat.com/en/privacy_policy.html"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </span>
                        ) : (
                          <div>
                            ({TEXT_AVAILABLE_POLICY[language]}
                            <span
                              onClick={() => {
                                FunctionOpenInNewTab(
                                  "https://www.wechat.com/en/privacy_policy.html"
                                );
                              }}
                              className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                            >
                              {TEXT_HERE[language]}
                            </span>
                            )
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_10[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab(
                              "https://www.viber.com/en/terms/viber-privacy-policy/"
                            );
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        )
                      </div>
                    </div>
                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_14[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab("https://signal.org/legal/");
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        )
                      </div>
                    </div>

                    <div className={` flex ${STYLE_SUB_NO_TERM}`}>
                      <li></li>
                      <div>
                        {TEXT_SOCIAL_MEDIA_11[language]} (
                        {TEXT_AVAILABLE_POLICY[language]}
                        <span
                          onClick={() => {
                            FunctionOpenInNewTab(
                              "https://www.kakaotalkapp.com/privacy"
                            );
                          }}
                          className={`${STYLE_LINK_BLUE_NO_MX} w-fit`}
                        >
                          {TEXT_HERE[language]}
                        </span>
                        )
                      </div>
                    </div>
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_SOCIAL_MEDIA_12[language]}
                  </div>
                  <div
                    className={`${STYLE_SUBTITLE_SEMIBOLD(
                      language
                    )} ${STYLE_UNDERLINE_PRIVACY} my-3`}
                  >
                    {TEXT_SECURYTY_IV[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_SECURYTY_1[language]}
                  </div>
                  <div className={`${STYLE_TEXT_DETAIL(language)}  `}>
                    {TEXT_SECURYTY_2[language]}
                    <span className="font-bold">
                      {TEXT_CLAUSE_II[language]}
                    </span>
                    {TEXT_SECURYTY_2_2[language]}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default PrivacyMain;
